module.exports = __webpack_public_path__ + "assets/2a2091e34afd2703cce9520d2382103d.mp3";